// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__35YiV","boxTitle":"Qualiphy_boxTitle__1gWv2","box":"Qualiphy_box__27kaR","toggleWrap":"Qualiphy_toggleWrap__2AxZ2"};